var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightChevronIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4279 11.9751L8.84961 8.39666L10.0605 7.18579L14.8496 11.9751L10.0605 16.7643L8.84961 15.5535L12.4279 11.9751Z",
    fill: "#B9BDC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChevronIcon);
export default __webpack_public_path__ + "static/media/rightChevronIcon.00ff213e518b446d838c0f2f2898b724.svg";
export { ForwardRef as ReactComponent };